<template>
  <div 
    class="footerClass mt-2"
    :style="isDark ? 'background-color: #242A3D;' : 'background-color: #E9E9E9;'"
  >
    <div class="col-12 d-flex align-items-center justify-content-center">
      <img
        class="logo"
        src="../../../assets/images/logo/vermelho_horizontal.png"
        alt="Logotipo"
      >
      <span class="ml-1">© {{ new Date().getFullYear() }} Portal Envios - Todos os direitos reservados</span>
    </div>
    <!-- Widget WhatsApp Flutuante -->
    <div
      id="whatsappWidget"
      class="whatsapp-widget"
    >
      <button
        id="whatsappButton"
        class="whatsapp-button"
        aria-label="Abrir WhatsApp"
        onclick="openWhatsApp();"
      >
        <svg viewBox="0 0 24 24">
          <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.91 2.78 15.79 3.97 17.33L2 22L6.94 20.11C8.45 21.05 10.2 21.59 12.04 21.59C17.5 21.59 21.95 17.14 21.95 11.68C21.95 6.22 17.5 2 12.04 2M12.04 20.09C10.36 20.09 8.74 19.59 7.35 18.65L6.98 18.42L4.27 19.3L5.17 16.71L4.92 16.32C3.8 14.85 3.19 13.07 3.19 11.23C3.19 6.45 7.11 2.77 12.04 2.77C16.97 2.77 20.89 6.45 20.89 11.23C20.89 16.01 16.97 20.09 12.04 20.09M16.56 13.88C16.29 13.75 15.03 13.13 14.78 13.04C14.53 12.95 14.34 12.9 14.15 13.18C13.96 13.46 13.42 14.03 13.26 14.21C13.1 14.39 12.94 14.41 12.67 14.28C11.78 13.86 11.14 13.53 10.5 12.77C9.96 12.15 9.6 11.39 9.44 11.06C9.28 10.73 9.42 10.58 9.56 10.45C9.68 10.33 9.84 10.13 9.97 9.97C10.1 9.81 10.15 9.68 10.24 9.47C10.33 9.26 10.28 9.07 10.22 8.94C10.16 8.81 9.81 7.53 9.68 7.12C9.55 6.72 9.41 6.68 9.21 6.67C9.02 6.66 8.8 6.66 8.58 6.66C8.36 6.66 8.02 6.73 7.73 7.04C7.44 7.35 6.63 8.13 6.63 9.73C6.63 11.33 7.75 12.88 7.91 13.09C8.07 13.3 9.6 15.56 12.01 16.51C13.14 16.95 14.01 17.18 14.7 17.35C15.44 17.53 16.12 17.5 16.64 17.43C17.22 17.36 18.44 16.82 18.68 16.21C18.92 15.6 18.92 15.09 18.86 14.97C18.8 14.85 18.67 14.77 18.46 14.68C18.24 14.59 16.83 14 16.56 13.88Z"/>
        </svg>
      </button>
      <span class="whatsapp-tooltip">Precisa de Ajuda? Fale com a equipe do Portal Envios.</span>
    </div>
  </div>
</template>
<script>
import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api'

export default {
  name: 'FooterInfo',

  setup() {
    const { skin } = useAppConfig()

    const isDark = computed(() => skin.value === 'dark')

    return { skin, isDark }
  },
}

</script>
<style>
  .footerClass {
    height: 130px;
    padding: 0.8rem 1rem;
    border-radius: 0.428rem;
    display: flex;
    align-items: center;
  }
  .logo {
    height: 30px;
  }
</style>